(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-sorting"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-kn-collection-filter]');
    if (!button) return;
    var original = button.closest('.kn-collection')?.querySelector('.kn-collection__main > div > .collection-filter-title');
    if (!original) return;
    original.click();
    button.setAttribute('aria-expanded', String(original.classList.contains('filter-collapse-show')));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kn-mobile-bottom-nav"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.kn-mobile-tabs .ltn__utilize-toggle');
    if (!trigger) return;
    var target = trigger.getAttribute('href');
    document.querySelectorAll('.ltn__utilize.ltn__utilize-open').forEach(function (drawer) {
      if ('#' + drawer.id === target) return;
      drawer.classList.remove('ltn__utilize-open');
      if (drawer.matches('[data-kn-mobile-drawer]')) {
        drawer.inert = true;
        drawer.setAttribute('aria-hidden', 'true');
      }
    });
  }, true);
  document.addEventListener('click', function (event) {
    if (event.detail === 0 || !event.target.closest('.kn-cart-drawer .ltn__utilize-close, .ltn__utilize-overlay')) return;
    window.setTimeout(function () {
      var focused = document.activeElement;
      if (focused && focused.matches('.kn-mobile-tabs__item, .kn-cart-drawer .ltn__utilize-close')) focused.blur();
    }, 0);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kn-mobile-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.querySelector('[data-kn-mobile-drawer]');
    if (!drawer) return;
    var panels = Array.from(drawer.querySelectorAll('[data-kn-mobile-panel]'));
    var title = drawer.querySelector('[data-kn-mobile-title]');
    var back = drawer.querySelector('[data-kn-mobile-back]');
    var close = drawer.querySelector('.kn-mobile-drawer__close');
    var searchInput = drawer.querySelector('#kn-mobile-search');
    var overlay = document.querySelector('.ltn__utilize-overlay');
    var stack = [];
    var current = 'shop';
    var opener = null;
    drawer.addEventListener('kn:offers-opening', function (event) {
      closeDrawer(false);
      event.detail.returnFocus = opener;
    });

    function show(id, push) {
      var target = panels.find(function (panel) { return panel.dataset.knMobilePanel === id; });
      if (!target || id === current && push) return;
      if (push) stack.push(current);
      panels.forEach(function (panel) {
        panel.classList.toggle('is-active', panel === target);
        panel.classList.toggle('is-before', panel.dataset.knMobilePanel === stack[stack.length - 1]);
        panel.setAttribute('aria-hidden', panel === target ? 'false' : 'true');
        panel.inert = panel !== target;
      });
      current = id;
      title.textContent = target.dataset.knTitle || '';
      back.hidden = stack.length === 0;
      target.scrollTop = 0;
    }

    function restoreClosedState(restoreFocus) {
      drawer.inert = true;
      drawer.setAttribute('aria-hidden', 'true');
      drawer.setAttribute('aria-modal', 'false');
      if (restoreFocus && opener && document.contains(opener)) opener.focus({ preventScroll: true });
    }

    function closeDrawer(restoreFocus) {
      drawer.classList.remove('ltn__utilize-open');
      if (!document.querySelector('.ltn__utilize.ltn__utilize-open')) {
        document.body.classList.remove('ltn__utilize-open');
        if (overlay) overlay.style.display = 'none';
      }
      restoreClosedState(restoreFocus);
    }

    function openMode(id, trigger) {
      opener = trigger;
      stack = [];
      document.querySelectorAll('.ltn__utilize.ltn__utilize-open').forEach(function (other) {
        if (other !== drawer) other.classList.remove('ltn__utilize-open');
      });
      drawer.inert = false;
      drawer.setAttribute('aria-hidden', 'false');
      drawer.setAttribute('aria-modal', 'true');
      show(id, false);
      drawer.classList.add('ltn__utilize-open');
      document.body.classList.add('ltn__utilize-open');
      if (overlay) overlay.style.display = 'block';
      if (id === 'search') searchInput?.focus({ preventScroll: true });
      else close.focus({ preventScroll: true });
    }

    // Own mobile menu opening so legacy drawer toggles cannot immediately close it.
    document.addEventListener('click', function (event) {
      if (window.matchMedia('(min-width: 1200px)').matches) return;
      var trigger = event.target.closest('[data-kn-mobile-open], .ltn__utilize-toggle[href="#ltn__utilize-mobile-menu"]');
      if (!trigger) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      openMode(trigger.dataset.knMobileOpen || 'shop', trigger);
    }, true);

    drawer.addEventListener('click', function (event) {
      var next = event.target.closest('[data-kn-mobile-next], [data-kn-mobile-switch]');
      if (next) {
        event.preventDefault();
        var id = next.dataset.knMobileNext || next.dataset.knMobileSwitch;
        show(id, true);
        if (id === 'search') searchInput?.focus({ preventScroll: true });
        else back.focus({ preventScroll: true });
      }
      if (event.target.closest('[data-kn-offers-open]')) {
        closeDrawer(false);
      }
      if (event.target.closest('[data-kn-mobile-size-compare]')) {
        event.preventDefault();
        closeDrawer(false);
        document.getElementById('size-compare-dialog-menu')?.showModal();
      }
    });
    back.addEventListener('click', function () {
      if (!stack.length) return;
      var previous = current;
      show(stack.pop(), false);
      drawer.querySelector('.is-active [data-kn-mobile-next="' + previous + '"]')?.focus({ preventScroll: true });
    });
    close.addEventListener('click', function () { closeDrawer(true); });
    overlay?.addEventListener('click', function () {
      if (drawer.classList.contains('ltn__utilize-open')) closeDrawer(true);
    });
    drawer.querySelector('.kn-mobile-drawer__search-form')?.addEventListener('submit', function (event) {
      if (searchInput.value.trim()) return;
      event.preventDefault();
      searchInput.focus({ preventScroll: true });
    });
    new MutationObserver(function () {
      if (!drawer.classList.contains('ltn__utilize-open')) restoreClosedState(false);
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    window.matchMedia('(min-width: 1200px)').addEventListener('change', function (event) {
      if (event.matches && drawer.classList.contains('ltn__utilize-open')) closeDrawer(false);
    });
    document.addEventListener('keydown', function (event) {
      if (!drawer.classList.contains('ltn__utilize-open')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        if (stack.length) back.click();
        else closeDrawer(true);
      }
      if (event.key === 'Tab') {
        var focusable = Array.from(drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled])')).filter(function (element) {
          return !element.closest('[inert]') && !element.hidden && element.getClientRects().length;
        });
        if (!focusable.length) return;
        var index = focusable.indexOf(document.activeElement);
        event.preventDefault();
        var nextIndex = index === -1 ? (event.shiftKey ? focusable.length - 1 : 0) : (index + (event.shiftKey ? -1 : 1) + focusable.length) % focusable.length;
        focusable[nextIndex].focus();
      }
    });
    show('shop', false);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kn-order-guide"] && !Shopify.designMode) return;
  try {
    (function () {
    function isVisible(element) {
      return !!element && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
    }

    function setup(root) {
      if (root.dataset.knGuideReady) return;
      var section = root.closest('[data-section="productTemplate"]');
      var form = root.closest('form') || (section && section.querySelector('#AddToCartForm'));
      if (!form) return;
      root.dataset.knGuideReady = 'true';
      var home = document.createComment('order guide position');
      var title = section && section.querySelector('#popup_cart_title');
      if (title) title.after(home);
      else root.parentNode.insertBefore(home, root);
      var imageAnchor = section && section.querySelector('.kn-order-guide__image-anchor');
      var desktop = window.matchMedia('(min-width: 1200px)');
      function placeLaunch() {
        if (imageAnchor && desktop.matches && !root.hasAttribute('data-custom-guide')) {
          imageAnchor.appendChild(root);
          root.classList.add('is-floating');
        } else if (home.parentNode) {
          root.classList.remove('is-floating');
          home.parentNode.insertBefore(root, home.nextSibling);
        }
      }
      placeLaunch();
      desktop.addEventListener('change', placeLaunch);
      var launch = root.querySelector('[data-kn-guide-launch]');
      var dock = root.querySelector('[data-kn-guide-dock]');
      var count = dock.querySelector('[data-kn-guide-count]');
      var segments = dock.querySelector('[data-kn-guide-steps]');
      var guideTitle = dock.querySelector('[data-kn-guide-title]');
      var body = dock.querySelector('[data-kn-guide-body]');
      var back = dock.querySelector('[data-kn-guide-back]');
      var next = dock.querySelector('[data-kn-guide-next]');
      var closeButton = dock.querySelector('[data-kn-guide-close]');
      function positionDock() {
        if (!imageAnchor || window.innerWidth < 992) {
          dock.style.left = '';
          return;
        }
        var columnLeft = imageAnchor.getBoundingClientRect().left;
        dock.style.left = Math.max(12, Math.min(columnLeft, window.innerWidth - dock.offsetWidth - 12)) + 'px';
      }
      var steps = [];
      var current = 0;
      var active = false;
      var highlighted = null;
      var timer = null;
      var queued = false;
      var veil = document.createElement('div');
      veil.className = 'kn-order-guide__veil';
      veil.setAttribute('aria-hidden', 'true');
      veil.hidden = true;
      for (var panelIndex = 0; panelIndex < 8; panelIndex += 1) veil.appendChild(document.createElement('span'));
      var veilPanels = Array.from(veil.children);
      document.body.appendChild(veil);
      document.body.appendChild(dock);

      function positionVeil() {
        if (!active || !highlighted) return;
        var rect = highlighted.getBoundingClientRect();
        var width = window.innerWidth;
        var height = window.innerHeight;
        var gap = highlighted.classList.contains('product-cart-action') ? 17 : 14;
        var left = Math.max(0, Math.min(width, rect.left - gap));
        var right = Math.max(0, Math.min(width, rect.right + gap));
        var top = Math.max(0, Math.min(height, rect.top - gap));
        var bottom = Math.max(0, Math.min(height, rect.bottom + gap));
        var radius = Math.max(0, Math.min(highlighted.classList.contains('product-cart-action') ? 10 : highlighted.classList.contains('custom-pricing-block') ? 12 : 16, (right - left) / 2, (bottom - top) / 2));
        veil.style.setProperty('--spotlight-radius', radius + 'px');
        [[0, 0, width, top], [0, bottom, width, height - bottom], [0, top, left, bottom - top], [right, top, width - right, bottom - top], [left, top, radius, radius], [right - radius, top, radius, radius], [left, bottom - radius, radius, radius], [right - radius, bottom - radius, radius, radius]].forEach(function (bounds, index) {
          var panel = veilPanels[index];
          panel.style.left = bounds[0] + 'px';
          panel.style.top = bounds[1] + 'px';
          panel.style.width = bounds[2] + 'px';
          panel.style.height = bounds[3] + 'px';
        });
      }

      function buildSteps() {
        var builder = form.querySelector('[data-custom-builder]');
        if (root.hasAttribute('data-custom-guide') && builder) {
          var size = builder.querySelector('.size-card.is-active .size-body');
          var photos = builder.querySelector('.size-card.is-active .photos');
          var add = builder.querySelector('#add');
          steps = [
            {key:'options',target:isVisible(size)?size:add,title:root.dataset.optionsTitle,body:root.dataset.optionsBody},
            {key:'upload',target:isVisible(photos)?photos:builder.querySelector('#empty'),title:root.dataset.uploadTitle,body:root.dataset.uploadBody},
            {key:'mix',target:add,title:root.dataset.mixTitle,body:root.dataset.mixBody},
            {key:'cart',target:builder.querySelector('.order-summary'),title:root.dataset.cartTitle,body:root.dataset.cartBody}
          ].filter(function(step){return isVisible(step.target);});
          root.hidden = !steps.length;
          return;
        }
        var variant = form.querySelector('.product-variant-option');
        var calculator = form.querySelector('.custom-pricing-block');
        var options = isVisible(calculator) ? calculator : variant;
        var hasOptions = isVisible(options) && (options === calculator || !!options.querySelector('.selector-wrapper select, .swatch input, select.single-option-selector'));
        if (variant && options === variant) options = variant.closest('.kn-order-guide__options-group') || variant;
        var upload = Array.from(form.querySelectorAll('.kn-uploadly-card, .uploadly-app')).find(isVisible);
        var cart = form.querySelector('.product-cart-action');
        var cartButton = cart && cart.querySelector('#AddToCart, .ph_clone_atc_btn, button[type="submit"]');
        steps = [];
        if (hasOptions) steps.push({ key: 'options', target: options, title: root.dataset.optionsTitle, body: root.dataset.optionsBody });
        if (upload) steps.push({ key: 'upload', target: upload, title: root.dataset.uploadTitle, body: root.dataset.uploadBody });
        if (isVisible(cart) && cartButton) steps.push({ key: 'cart', target: cart, title: root.dataset.cartTitle, body: root.dataset.cartBody });
        root.hidden = !steps.some(function (step) { return step.key === 'cart'; });
      }

      function scrollToStep() {
        var step = steps[current];
        if (!step) return;
        if (highlighted && highlighted !== step.target) highlighted.classList.remove('kn-order-guide__target--active');
        highlighted = step.target;
        highlighted.classList.add('kn-order-guide__target--active');
        step.target.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        positionVeil();
      }

      function render(shouldScroll) {
        if (!active || !steps.length) return;
        current = Math.min(current, steps.length - 1);
        var step = steps[current];
        dock.hidden = false;
        veil.hidden = false;
        root.classList.add('is-active');
        count.textContent = root.dataset.step + ' ' + (current + 1) + ' ' + root.dataset.of + ' ' + steps.length;
        guideTitle.textContent = step.title;
        body.textContent = step.body;
        segments.replaceChildren();
        steps.forEach(function (_, index) {
          var segment = document.createElement('span');
          if (index === current) segment.className = 'is-current';
          else if (index < current) segment.className = 'is-visited';
          segments.appendChild(segment);
        });
        back.hidden = current === 0;
        next.hidden = current === steps.length - 1;
        next.disabled = false;
        positionDock();
        if (shouldScroll) scrollToStep();
        else positionVeil();
      }

      function sync() {
        var key = steps[current] && steps[current].key;
        buildSteps();
        if (!active) return;
        if (root.hidden) {
          close(false);
          return;
        }
        var index = steps.findIndex(function (step) { return step.key === key; });
        if (index !== -1) current = index;
        render(false);
      }

      function scheduleSync() {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; sync(); });
      }

      function close(refocus) {
        active = false;
        dock.hidden = true;
        veil.hidden = true;
        root.classList.remove('is-active');
        if (highlighted) highlighted.classList.remove('kn-order-guide__target--active');
        highlighted = null;
        if (timer) clearInterval(timer);
        timer = null;
        if (refocus) launch.focus({ preventScroll: true });
      }

      root.knGuideOpen = function () {
        buildSteps();
        if (root.hidden) return;
        current = 0;
        active = true;
        render(true);
        if (!timer) timer = setInterval(scheduleSync, 700);
      };
      launch.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (!active) root.knGuideOpen();
      });
      next.addEventListener('click', function () {
        if (!steps[current]) return;
        current += 1;
        render(true);
      });
      back.addEventListener('click', function () {
        current = Math.max(0, current - 1);
        render(true);
      });
      closeButton.addEventListener('click', function () { close(true); });
      veil.addEventListener('click', function () { close(true); });
      window.addEventListener('resize', positionVeil);
      window.addEventListener('resize', positionDock);
      document.addEventListener('scroll', positionVeil, true);
      document.addEventListener('keydown', function (event) {
        if (active && event.key === 'Escape') close(true);
      });
      form.addEventListener('change', scheduleSync);
      form.addEventListener('input', scheduleSync);
      new MutationObserver(scheduleSync).observe(form, { childList: true, subtree: true });
      document.addEventListener('shopify:section:unload', function (event) {
        if (section && event.target.contains(section)) {
          close(false);
          veil.remove();
          dock.remove();
          root.remove();
          window.removeEventListener('resize', positionVeil);
          window.removeEventListener('resize', positionDock);
          document.removeEventListener('scroll', positionVeil, true);
          desktop.removeEventListener('change', placeLaunch);
        }
      });
      buildSteps();
    }

    function setupAll() {
      document.querySelectorAll('[data-kn-order-guide]').forEach(setup);
    }
    document.addEventListener('click', function (event) {
      var launch = event.target.closest('[data-kn-guide-launch]');
      if (!launch) return;
      var root = launch.closest('[data-kn-order-guide]');
      if (!root) return;
      event.preventDefault();
      event.stopPropagation();
      setup(root);
      if (root.knGuideOpen && !root.classList.contains('is-active')) root.knGuideOpen();
    }, true);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupAll, { once: true });
    else setupAll();
    document.addEventListener('shopify:section:load', setupAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
